export const CATEGORY_DICT: { [key in string]: string } = {
  career: '経歴・キャリア',
  birthplace: '出身地',
  company_phase: '会社のフェーズ',
  hobby: '趣味',
  decision_style: '意思決定スタイル',
  connection: 'つながり',
}
